var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "detailCanvas",
      staticClass: "detailContent canvas-box",
      attrs: { id: "detailCanvas" },
    },
    [
      _c("div", { staticClass: "title" }, [
        _c("div", { staticClass: "title-name" }, [
          _vm._v(_vm._s(_vm.$t("data.payout_details"))),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "detail-card" },
        [
          _vm.merchantInfo.transaction_type === _vm.TRANSACTION_TYPE_FX
            ? [
                _c("div", { staticClass: "info-amount-txt" }, [
                  _vm._v(_vm._s(_vm.$t("data.destination_amount")) + ":"),
                ]),
                _c("div", { staticClass: "info-amount" }, [
                  _vm._v(
                    _vm._s(_vm.merchantInfo.destination_currency) +
                      " " +
                      _vm._s(
                        _vm._f("toDivideWithDot")(
                          _vm.merchantInfo.destination_amount
                        )
                      )
                  ),
                ]),
                _c("div", { staticClass: "info-amount-txt" }, [
                  _vm._v(_vm._s(_vm.$t("data.source_amount")) + ":"),
                ]),
                _c("div", { staticClass: "info-amount" }, [
                  _vm._v(
                    _vm._s(_vm.merchantInfo.source_currency) +
                      " " +
                      _vm._s(
                        _vm._f("toDivideWithDot")(
                          _vm.merchantInfo.source_amount
                        )
                      )
                  ),
                ]),
                _c("div", { staticClass: "info-amount-txt" }, [
                  _vm._v(_vm._s(_vm.$t("data.fee")) + "::"),
                ]),
                _c("div", { staticClass: "info-amount" }, [
                  _vm._v(
                    _vm._s(
                      _vm.merchantInfo.mch_foreign_exchange_fee_resp
                        .fee_split_currency
                    ) +
                      " " +
                      _vm._s(
                        _vm._f("toDivideWithDot")(
                          _vm.merchantInfo.mch_foreign_exchange_fee_resp
                            .fee_split
                        )
                      )
                  ),
                ]),
              ]
            : [
                _c("div", { staticClass: "info-amount-txt" }, [
                  _vm._v(_vm._s(_vm.$t("data.destination_amount")) + ":"),
                ]),
                _c("div", { staticClass: "info-amount" }, [
                  _vm._v(
                    _vm._s(_vm.showDestinationCurrency) +
                      " " +
                      _vm._s(
                        _vm._f("toDivideWithDot")(
                          _vm.merchantInfo.po_trans_amount
                        )
                      )
                  ),
                ]),
                _c("div", { staticClass: "info-amount-txt" }, [
                  _vm._v(_vm._s(_vm.$t("data.fee")) + ":"),
                ]),
                _c("div", { staticClass: "info-amount" }, [
                  _vm._v(
                    _vm._s(_vm.showFeeCurrency) +
                      " " +
                      _vm._s(
                        _vm._f("toDivideWithDot")(_vm.merchantInfo.fee_split)
                      )
                  ),
                ]),
              ],
          _c("div", {
            staticClass: "line",
            staticStyle: { marginTop: "10px", marginBottom: "9px" },
          }),
          _c(
            "div",
            { staticClass: "modalRow flex", staticStyle: { height: "39px" } },
            [
              _c("div", { staticClass: "modalCol col-min-width" }, [
                _vm._v(_vm._s(_vm.$t("merchantAccount.transaction_id")) + "："),
              ]),
              _c("div", { staticClass: "modalCol moreBlock" }, [
                _vm._v(_vm._s(_vm.merchantInfo.transaction_id)),
              ]),
            ]
          ),
          _c("div", { staticClass: "modalRow flex" }, [
            _c("div", { staticClass: "modalCol" }, [
              _vm._v(_vm._s(_vm.$t("merchantAccount.create_time")) + "："),
            ]),
            _c("div", { staticClass: "modalCol moreBlock" }, [
              _vm._v(_vm._s(_vm.merchantInfo.transaction_create_time)),
            ]),
          ]),
          _c("div", { staticClass: "modalRow flex" }, [
            _c("div", { staticClass: "modalCol col-min-width" }, [
              _vm._v(_vm._s(_vm.$t("merchantAccount.complete_time")) + "："),
            ]),
            _c("div", { staticClass: "modalCol moreBlock" }, [
              _vm._v(_vm._s(_vm.merchantInfo.transaction_return_time)),
            ]),
          ]),
          _c("div", { staticClass: "modalRow flex" }, [
            _c("div", { staticClass: "modalCol col-min-width" }, [
              _vm._v(_vm._s(_vm.$t("customerService.remitting_bank")) + "："),
            ]),
            _c("div", { staticClass: "modalCol moreBlock" }, [
              _vm._v(_vm._s(_vm.merchantInfo.sender_bank_name)),
            ]),
          ]),
          _c("div", { staticClass: "modalRow flex" }, [
            _c("div", { staticClass: "modalCol col-min-width" }, [
              _vm._v(
                _vm._s(_vm.$t("customerService.remittance_account")) + "："
              ),
            ]),
            _c("div", { staticClass: "modalCol moreBlock" }, [
              _vm._v(
                _vm._s(
                  _vm._f("strAesDecryptAndAsterisk")(
                    _vm.merchantInfo.sender_bank_account
                  )
                )
              ),
            ]),
          ]),
          _c("div", { staticClass: "modalRow flex" }, [
            _c("div", { staticClass: "modalCol col-min-width" }, [
              _vm._v(_vm._s(_vm.$t("merchantAccount.recipient_name")) + "："),
            ]),
            _c("div", { staticClass: "modalCol moreBlock" }, [
              _vm._v(
                _vm._s(
                  _vm._f("strAesDecryptAndAsterisk")(
                    _vm.merchantInfo.recipient_name
                  )
                )
              ),
            ]),
          ]),
          _c("div", { staticClass: "modalRow flex" }, [
            _c("div", { staticClass: "modalCol col-min-width" }, [
              _vm._v(_vm._s(_vm.$t("merchantAccount.recipient_mobile")) + "："),
            ]),
            _c("div", { staticClass: "modalCol moreBlock" }, [
              _vm._v(_vm._s(_vm.merchantInfo.recipient_mobile)),
            ]),
          ]),
          _c("div", { staticClass: "modalRow flex" }, [
            _c("div", { staticClass: "modalCol col-min-width" }, [
              _vm._v(
                _vm._s(_vm.$t("merchantAccount.recipient_channel")) + "："
              ),
            ]),
            _c("div", { staticClass: "modalCol moreBlock" }, [
              _vm._v(_vm._s(_vm.merchantInfo.recipient_channel)),
            ]),
          ]),
          _c("div", { staticClass: "modalRow flex" }, [
            _c("div", { staticClass: "modalCol col-min-width" }, [
              _vm._v(
                _vm._s(_vm.$t("merchantAccount.recipient_account")) + "："
              ),
            ]),
            _c("div", { staticClass: "modalCol moreBlock" }, [
              _vm._v(
                _vm._s(
                  _vm._f("strAesDecryptAndAsterisk")(
                    _vm.merchantInfo.recipient_account
                  )
                )
              ),
            ]),
          ]),
          _c("div", { staticClass: "modalRow flex" }, [
            _c("div", { staticClass: "modalCol col-min-width" }, [
              _vm._v(_vm._s(_vm.$t("data.remark")) + "："),
            ]),
            _c("div", { staticClass: "modalCol moreBlock" }, [
              _vm._v(_vm._s(_vm.merchantInfo.product_name)),
            ]),
          ]),
          _c("div", {
            staticClass: "line",
            staticStyle: { marginBottom: "10px", marginTop: "5px" },
          }),
          _c("div", { staticClass: "download-time" }, [
            _vm._v(
              _vm._s(_vm.$t("data.download_time")) +
                ": " +
                _vm._s(_vm._f("parseTime")(Date.now()))
            ),
          ]),
        ],
        2
      ),
      _c(
        "el-tag",
        {
          staticClass: "modalBtn",
          attrs: {
            type: _vm.getPOTransactionStatusType(
              _vm.merchantInfo.po_trans_status
            ),
          },
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.getPOTransactionStatusMap(_vm.merchantInfo.po_trans_status)
              )
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }